import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Statistic, Spin } from "antd";
import {
  UserOutlined,
  MailOutlined,
  AppstoreOutlined,
  PullRequestOutlined,
  ContactsOutlined,
} from "@ant-design/icons";
import Layout from "../../ReusableComponents/Layout";
import apiClient from "../../api/client";

const statCards = [
  {
    key: "users",
    title: "Total Users",
    icon: <UserOutlined />,
    color: "#1890ff",
    path: "/users",
  },
  {
    key: "guests",
    title: "Total Guests",
    icon: <MailOutlined />,
    color: "#52c41a",
    path: "/users?tab=guests",
  },
  {
    key: "services",
    title: "Total Services",
    icon: <AppstoreOutlined />,
    color: "#faad14",
    path: "/services",
  },
  {
    key: "requests",
    title: "Pending Requests",
    icon: <PullRequestOutlined />,
    color: "#eb2f96",
    path: "/req-org",
  },
  {
    key: "contacts",
    title: "Contact Messages",
    icon: <ContactsOutlined />,
    color: "#722ed1",
    path: "/contact-us",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [usersRes, guestsRes, servicesRes, requestsRes, contactsRes] =
          await Promise.all([
            apiClient.get("/getAllUsers", { params: { page: 0, limit: 1 } }),
            apiClient.get("/getAllGuests", { params: { page: 0, limit: 1 } }),
            apiClient.get("/get-services"),
            apiClient.get("/get-reqCompanies", { params: { page: 0 } }),
            apiClient.get("/get-constactUs"),
          ]);

        setStats({
          users: usersRes.data?.pagination?.totalItems ?? 0,
          guests: guestsRes.data?.pagination?.totalItems ?? 0,
          services: servicesRes.data?.data?.length ?? 0,
          requests: requestsRes.data?.pagination?.totalItems ?? 0,
          contacts: contactsRes.data?.data?.length ?? 0,
        });
      } catch (err) {
        console.error("Failed to fetch dashboard stats", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return (
    <Layout>
      <Spin spinning={loading}>
        <Row gutter={[24, 24]}>
          {statCards.map((card) => (
            <Col key={card.key} xs={24} sm={12} md={8} lg={8} xl={4}>
              <Card
                hoverable
                onClick={() => navigate(card.path)}
                style={{ borderTop: `3px solid ${card.color}` }}
              >
                <Statistic
                  title={card.title}
                  value={stats[card.key] ?? 0}
                  prefix={React.cloneElement(card.icon, {
                    style: { color: card.color, fontSize: 24 },
                  })}
                  valueStyle={{ color: card.color }}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Spin>
    </Layout>
  );
};

export default Home;
